import { render, staticRenderFns } from "./coinspaid-withdraw.vue?vue&type=template&id=f6e74b06"
import script from "./coinspaid-withdraw.vue?vue&type=script&lang=js"
export * from "./coinspaid-withdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports